// ---- Mobile nav ----
const menuToggle = document.getElementById("menuToggle");
const navLinks = document.getElementById("navLinks");
if (menuToggle && navLinks) {
  menuToggle.addEventListener("click", () => {
    const open = navLinks.classList.toggle("open");
    menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
  });
  navLinks.querySelectorAll("a").forEach((a) =>
    a.addEventListener("click", () => {
      navLinks.classList.remove("open");
      menuToggle.setAttribute("aria-expanded", "false");
    })
  );
}

// ---- Reveal on scroll (also drives the growth-divider signature animation) ----
const revealEls = document.querySelectorAll(".reveal");
const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.2 }
);
revealEls.forEach((el) => revealObserver.observe(el));


// ---- Bundle tier selection ----
(function () {
  const form = document.getElementById("offerForm");
  if (!form) return;
  const hidden = document.getElementById("offerVariant");
  const priceOut = document.getElementById("offerPrice");
  const stickyPrice = document.getElementById("stickyPrice");
  const radios = form.querySelectorAll('input[name="tier"]');
  function sync(radio) {
    hidden.value = radio.value;
    if (priceOut) priceOut.textContent = radio.dataset.price;
    if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
  }
  radios.forEach(function (r) { r.addEventListener("change", function () { sync(r); }); });
  const checked = form.querySelector('input[name="tier"]:checked');
  if (checked) sync(checked);
})();

// ---- Sticky mobile buy bar ----
(function () {
  const bar = document.getElementById("stickyBuy");
  const offer = document.getElementById("order");
  const hero = document.getElementById("top");
  if (!bar || !offer) return;
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target === hero) bar.classList.toggle("up", !entry.isIntersecting);
      if (entry.target === offer && entry.isIntersecting) bar.classList.remove("up");
    });
  }, { threshold: 0.05 });
  if (hero) io.observe(hero);
  io.observe(offer);
})();
